import 'babel-polyfill';
import Vue from 'vue'
import App from './App.vue'
import './plugins/element'
import ElementUI from 'element-ui'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import "./assets/fonts/iconfont/iconfont.css";
import md5 from 'js-md5'
Vue.use(BootstrapVue)
 Vue.prototype.$md5 = md5
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.filter('dateFormat', function(originVal) {
  const dt = new Date(originVal)

  const y = dt.getFullYear()
  const m = (dt.getMonth() + 1 + '').padStart(2, '0')
  const d = (dt.getDate() + '').padStart(2, '0')

  const hh = (dt.getHours() + '').padStart(2, '0')
  const mm = (dt.getMinutes() + '').padStart(2, '0')
  const ss = (dt.getSeconds() + '').padStart(2, '0')

  return `${y}年${m}月${d}日 `
})

Vue.config.productionTip = false
Vue.use(ElementUI)
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
